import { render, staticRenderFns } from "./headerIndex.vue?vue&type=template&id=2d52970b&scoped=true"
import script from "./headerIndex.vue?vue&type=script&lang=js"
export * from "./headerIndex.vue?vue&type=script&lang=js"
import style0 from "./headerIndex.vue?vue&type=style&index=0&id=2d52970b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52970b",
  null
  
)

export default component.exports